// @flow

import type { ACFVerticalAlign } from '../../../types';

type MapperType = {
  [key: ACFVerticalAlign]: string,
};

export const alignmentMapper: MapperType = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end',
  spread: 'space-between',
};

export default null;
